export const isIOS = Boolean(navigator.userAgent.match(/ipad|ipod|iphone/i))
